{
  "user": {
    "addAdditionalMembers": {
      "addOtherMembers": "Add other members to this time",
      "selectAUser": "Select a User *",
      "searchPlaceholder": "Start typing their name here",
      "searchingForOtherMembers": "Searching for other members",
      "searchResults": "Search results",
      "addThisUser": "Add this user",
      "lookingForMember": "Looking for a member on your account? Make sure they are",
      "associatedWithMembership": "associated with the membership",
      "usersToInclude": "Users to include:"
    },
    "bookingCollisionModal": {
      "bookingSlotAvailability": "Booking Slot Availability",
      "loadingDetails": "Loading details...",
      "loadingAvailabilityDetails": "Loading availability details...",
      "requestHasConflicts": "Your booking request has some conflicts with existing bookings. You can choose to book only the available slots, or cancel and modify your request.",
      "slotsAvailable": "{count} slot(s) are available and can be booked.",
      "noSlotsAvailable": "No slots are currently available for the requested time or series.",
      "conflictingSlots": "Conflicting Slot(s):",
      "bookAvailableSlots": "Book {count} Available Slot(s)"
    },
    "bookingSuccess": {
      "bookingSubmitted": "Booking Submitted",
      "confirmationMessage": "Your booking has been successfully submitted. You will receive an email confirmation shortly.",
      "createAnotherBooking": "Create Another Booking",
      "viewMyBookings": "View My Bookings"
    },
    "dropInSignup": {
      "signup": "Signup",
      "signupComplete": "Signup complete! You will receive an email with confirmation details.",
      "signedUpManageSignups": "You're signed up! To manage your signups,",
      "clickHere": "click here"
    },
    "dropInSignupFlow": {
      "signupComplete": "Signup complete! You will receive an email with confirmation details.",
      "title": "TITLE",
      "description": "DESCRIPTION",
      "signedUpManageSignups": "You're signed up! To manage your signups",
      "clickHere": "click here."
    },
    "flowBookingCreation": {
      "membershipRequired": "You must have the required membership to book this facility.",
      "login": "Login",
      "viewMemberships": "View Memberships",
      "viewMyBookings": "View My Bookings",
      "selectBookingOwner": "Please select a booking owner before continuing.",
      "addPlayingPartner": "At least one playing partner must be added to your booking.",
      "formValidationTimeout": "Form validation timed out. Please try again.",
      "ownerUndetermined": "Could not determine the booking owner. Please re-select and try again.",
      "guestCreationFailed": "Failed to create guest account. Please try again.",
      "createBookingError": "An error occurred while creating your booking. Please try again.",
      "noAvailableSlots": "No available slots to book or original request details are missing.",
      "bookAvailableSlotsError": "An error occurred while booking available slots. Please try again."
    },
    "formReviewBooking": {
      "bookingDetails": "Booking Details",
      "dateAndTime": "Date & Time",
      "bookingTypeLabel": "Booking Type",
      "format": "Format",
      "dropIn": "Drop-in",
      "activity": "Activity",
      "requiresApproval": "This booking requires approval before being finalized.",
      "confirmedInstantlyAfterPayment": "This booking will be confirmed instantly after payment is processed.",
      "confirmedInstantly": "This booking will be confirmed instantly.",
      "yourCost": "Your Cost",
      "hourlyRate": "Hourly Rate",
      "selectedProducts": "Selected Products",
      "recurringDetails": "Recurring Details",
      "frequency": "Frequency",
      "days": "Days",
      "until": "Until",
      "yourInformation": "Your Information",
      "name": "Name",
      "email": "Email",
      "phone": "Phone",
      "notAvailable": "N/A",
      "additionalMembers": "Additional Members",
      "additionalInformation": "Additional Information",
      "customFormCompleted": "Custom form completed"
    },
    "setBookingOwner": {
      "whoIsThisBookingFor": "Who is this booking for?",
      "createForYourselfOrSomeoneElse": "Create a booking for yourself or someone else on your account."
    },
    "formNumberOfGuests": {
      "howManyGuests": "How many guests are you bringing?"
    },
    "formReason": {
      "reasonHelp": "Optionally enter a short reason for your booking. Note that if supplied, this will be publicly visible on the calendar.",
      "reasonLabel": "Reason *",
      "reasonPlaceholder": "Enter a reason"
    },
    "formRecurringDetails": {
      "frequencyLabel": "Frequency *",
      "days": "Days",
      "until": "Until *"
    },
    "formSelectDateAndTime": {
      "listView": "List",
      "calendarView": "Calendar",
      "yourBookingDetails": "Your Booking Details",
      "changeTime": "Change Time",
      "facility": "Facility",
      "bookingType": "Booking Type",
      "format": "Format",
      "dropIn": "Drop-in",
      "activity": "Activity",
      "requiresApproval": "This booking requires approval before being finalized.",
      "confirmedInstantly": "This booking will be confirmed instantly.",
      "dateAndTime": "Date & Time",
      "yourCost": "Your Cost",
      "hourlyRate": "Hourly Rate",
      "perHour": "/ hr",
      "pickADate": "Pick a date",
      "bookingDuration": "Booking duration",
      "hours": "hours",
      "minutes": "minutes",
      "selectATime": "Select a time",
      "noAvailableTimes": "No available times on this date.",
      "booked": "Booked",
      "full": "Full",
      "selectDatePrompt": "Select a date to see available times.",
      "selectDateAndTime": "Select a Date and Time",
      "calendarInstructions": "Click and drag on the calendar to select a time slot for your booking. Available time slots will be highlighted when you hover over them."
    },
    "facilityBookings": {
      "title": "My Bookings"
    }
  },
  "manager": {
    "adminBookingCollisionModal": {
      "bookingSlotAvailability": "Booking Slot Availability",
      "loadingDetails": "Loading details...",
      "loadingAvailabilityDetails": "Loading availability details...",
      "adminOverrideAvailable": "Admin Override Available:",
      "overrideOptionsDescription": "You can choose to book with conflicts, book only available slots, or cancel.",
      "conflictsIntro": "Your booking request has some conflicts with existing bookings. As an admin, you have the following options:",
      "slotsAvailableForBooking": "slot(s) are available for booking without conflicts.",
      "noSlotsAvailable": "No slots are available",
      "forBookingWithoutConflicts": "for booking without conflicts.",
      "conflictingSlots": "Conflicting Slot(s):",
      "conflictItemId": "(ID: {id})",
      "bookAvailableSlots": "Book {count} Available Slot(s)",
      "overrideAndBook": "Override & Book With Conflicts"
    },
    "bookingItemDetails": {
      "lockerRoomOne": "Locker Room 1",
      "noItemsCreated": "No items created",
      "selectAnItem": "Select an item",
      "optionalDescription": "Optional description",
      "clickHere": "Click here",
      "toCreateItems": "to create items.",
      "lockerRoomTwo": "Locker Room 2",
      "noItemsCreatedMessage": "No items created.",
      "editItems": "Edit Items",
      "saveItems": "Save Items"
    },
    "bookingSidebar": {
      "createBooking": "Create Booking",
      "dateAndTime": "Date & Time",
      "facility": "Facility",
      "selectAFacility": "Select a facility",
      "pleaseSelectAFacility": "Please select a facility.",
      "start": "Start",
      "end": "End",
      "timesShownIn": "Times shown in",
      "bookingType": "Booking Type",
      "required": "Required",
      "dropInDetails": "Drop In Details",
      "titleRequired": "Title *",
      "enterATitle": "Enter a title",
      "descriptionRequired": "Description *",
      "limitRequired": "Limit *",
      "blockDetails": "Block Details",
      "reasonRequired": "Reason *",
      "enterAReasonForBlocking": "Enter a reason for blocking",
      "calendarDisplayText": "Calendar Display Text",
      "optional": "Optional",
      "characterCount": "{count}/30 characters",
      "contactDetails": "Contact Details",
      "fullNameRequired": "Full Name *",
      "fullName": "Full Name",
      "emailRequired": "Email *",
      "enterAnEmailForTheGuest": "Enter an email for the guest",
      "telephoneRequired": "Telephone *",
      "enterAPhoneNumber": "Enter a phone number",
      "pleaseSelectAMember": "Please search for & select a member from the list.",
      "familyMembersNote": "Note: Only members can be added to booking requests. Family members cannot be added.",
      "additionalDetails": "Additional Details",
      "reason": "Reason",
      "enterAReason": "Enter a reason",
      "frequency": "Frequency",
      "notifications": "Notifications",
      "sendConfirmationEmail": "Send booking confirmation email to the booking contact",
      "items": "Items",
      "itemOne": "Item 1",
      "description": "Description",
      "optionalDescription": "Optional.",
      "itemTwo": "Item 2",
      "searchingForConflicts": "Searching for booking conflicts...",
      "noAvailableSlots": "No available slots to book or original request details are missing.",
      "availableSlotsBooked": "Available slots booked successfully!",
      "bookAvailableSlotsError": "An error occurred while booking available slots: {message}",
      "unknownError": "Unknown error",
      "originalRequestMissing": "Original request details are missing.",
      "bookingCreatedWithOverride": "Booking created successfully with conflicts overridden!",
      "overrideConflictsError": "An error occurred while overriding conflicts: {message}",
      "bookingCreated": "Booking created successfully!",
      "errorSavingBooking": "Error saving booking. Please try again or contact support."
    },
    "bookingStateConfig": {
      "addNewState": "Add New State",
      "stateName": "State Name",
      "stateColor": "State Color",
      "visibleOnCalendars": "Visible on calendars",
      "visibilityHelp": "When enabled, booking requests in this state will be visible to members and block that time from being booked. Guests will also see these bookings on public calendars.",
      "addState": "Add State",
      "currentStates": "Current States",
      "dragToReorder": "Drag to re-order",
      "visible": "Visible",
      "hidden": "Hidden",
      "visibleLegend": "= Shown to members (and guests on public calendars), blocks time",
      "hiddenLegend": "= Only visible to facility managers",
      "deleteState": "Delete State",
      "deleteConfirm": "Delete {name}? This cannot be undone.",
      "bookingStatesUpdated": "Booking states updated!",
      "failedUpdateStateOrder": "Failed to update state order",
      "failedAddBookingState": "Failed to add booking state",
      "nowVisibleOnCalendars": "\"{name}\" is now visible on calendars",
      "nowHiddenFromCalendars": "\"{name}\" is now hidden from calendars",
      "failedUpdateVisibility": "Failed to update visibility setting",
      "stateNameRequired": "State name is required",
      "bookingStateUpdated": "Booking state updated!",
      "failedUpdateBookingState": "Failed to update booking state",
      "createdButNotDeleted": "A new state was created but the original could not be deleted. Retry or remove it manually.",
      "failedDeleteBookingState": "Failed to delete booking state",
      "bookingState": "Booking state",
      "failedCreateReplacementState": "Failed to create replacement state"
    },
    "dropInTimeslotView": {
      "generalInformation": "General Information",
      "statusLabel": "Status:",
      "statusDeleted": "Deleted",
      "statusFull": "Full",
      "statusOpen": "Open",
      "createdLabel": "Created:",
      "timeslotDetails": "Timeslot Details",
      "facilityLabel": "Facility:",
      "dateTimeLabel": "Date & Time:",
      "signupsLabel": "Signups:",
      "spotLeft": "({count} spot left)",
      "spotsLeft": "({count} spots left)",
      "noSignupLimit": "(no signup limit)",
      "editTimeslot": "Edit {title}",
      "signupLimit": "Signup limit",
      "maximumSignups": "Maximum signups",
      "leaveAtZeroForNoLimit": "Leave at 0 for no limit.",
      "yourSignups": "Your Signups",
      "signups": "Signups",
      "headTitle": "View Timeslot",
      "timeslot": "Timeslot",
      "signupLimitUpdated": "Signup limit updated.",
      "unableToUpdateSignupLimit": "Unable to update signup limit."
    },
    "entityNotes": {
      "createNote": "Create Note",
      "noNotesFound": "No notes found.",
      "createdBy": "Created by:",
      "created": "Created",
      "editNote": "Edit Note",
      "addNote": "Add Note",
      "note": "Note",
      "applyToRecurringBookings": "Apply this note to all associated recurring bookings",
      "confirmDelete": "Are you sure you want to delete this note?"
    },
    "invoicesForBooking": {
      "associateInvoice": "Associate Invoice",
      "createInvoice": "Create Invoice",
      "includeRecurringSeries": "Include Recurring Series",
      "includeRecurringBookings": "Include Recurring Bookings",
      "removeAssociationConfirm": "Are you sure you want to remove this invoice's association with this booking? The invoice itself will not be deleted.",
      "invoiceAssociated": "Invoice associated with booking.",
      "invoiceAssociationRemoved": "Invoice association removed."
    },
    "recurFormFields": {
      "recurringFrequency": "Recurring Frequency",
      "recursEveryWeekOn": "Recurs every week on *",
      "pleaseSelectAtLeastOneDay": "Please select at least one day.",
      "everyDay": "Every Day",
      "repeatsEvery": "Repeats every",
      "recursUntil": "Recurs Until *",
      "pleaseSelectADate": "Please selected a date.",
      "lockerRooms": "Locker Rooms",
      "itemsAddedToAllBookings": "Any associated locker rooms will be added to all bookings in the recurring series.",
      "itemsOnFirstBookingOnly": "Only the first booking will include the items.",
      "includeLockerRoomsOnAllBookings": "Include locker rooms on all bookings",
      "frequencyNever": "Never",
      "frequencyWeekly": "Weekly",
      "frequencyMonthly": "Monthly",
      "mondayShort": "M",
      "tuesdayShort": "T",
      "wednesdayShort": "W",
      "thursdayShort": "Th",
      "fridayShort": "F",
      "saturdayShort": "Sa",
      "sundayShort": "Su",
      "dayOfEveryMonth": "{day} of every month"
    },
    "recurringBookingListContainer": {
      "modifyState": "Modify State",
      "declined": "Declined",
      "unknown": "Unknown",
      "active": "Active",
      "columnId": "ID",
      "columnFacility": "Facility",
      "columnStart": "Start",
      "columnEnd": "End",
      "columnStatus": "Status",
      "bookingsDeleted": "Bookings deleted successfully",
      "failedDeleteBookings": "Failed to delete bookings",
      "failedUpdateState": "Failed to update state. Please try again or contact support if the problem persists."
    },
    "startEndDisplay": {
      "start": "Start",
      "end": "End"
    },
    "timeRangeSelectionModal": {
      "validatingTimeRange": "Validating time range...",
      "selectCalendarRangeHelp": "Select how far in advance you'd like to see calendar events. The system will optimize the range if there are too many events.",
      "calendarRange": "Calendar Range",
      "alwaysIncludesPast30Days": "Always includes the past 30 days",
      "calendarInformation": "Calendar Information",
      "requested": "Requested:",
      "monthsForward": "{months} months forward",
      "youllReceive": "You'll receive:",
      "limitedEventsWarning": "Due to the number of events in your selected range, you will be able to see up to {months} {unit} in advance",
      "month": "month",
      "months": "months",
      "subscriptionUrl": "Subscription URL",
      "calendarUpdateInterval": "Calendar updates every 5 minutes. Changes made in your personal calendar won't affect the main booking system.",
      "differentCalendarsUpdateRates": "Different Calendars may pull updates at different rates.",
      "validating": "Validating...",
      "validateRange": "Validate Range",
      "copyUrl": "Copy URL",
      "nMonths": "{count} Months",
      "subscribeTo": "Subscribe to {name}",
      "calendar": "Calendar",
      "validationErrorTitle": "Validation Error",
      "validationErrorMessage": "Unable to validate time range. Please try again.",
      "copiedTitle": "Copied!",
      "copiedMessage": "Calendar subscription URL copied to clipboard",
      "copyFailedTitle": "Copy Failed",
      "copyFailedMessage": "Unable to copy calendar link"
    },
    "viewBooking": {
      "bookingNumber": "Booking #{id}",
      "moreActions": "More Actions",
      "createInvoice": "Create Invoice",
      "sendBookingDetails": "Send Booking Details",
      "noFormAssociated": "There is no form associated with this booking.",
      "formResponsesLocked": "Form responses are locked.",
      "usersCannotModifyResponses": "Users cannot submit or modify responses.",
      "unlockResponses": "Unlock Responses",
      "lockResponses": "Lock Responses",
      "noFormSubmissions": "There are no form submissions to display. An admin can fill out the form on behalf of the user or share a link to fill out the form by clicking the Share Public Link button to copy it.",
      "send": "Send",
      "sendEmailConfirmation": "This will send an email with the booking details to",
      "theBookingContact": "the booking contact",
      "recurringSeriesNote": "The email will include all dates in the recurring series.",
      "lockSuccess": "Form responses locked!",
      "lockFailed": "Failed to lock form responses.",
      "unlockSuccess": "Form responses unlocked!",
      "unlockFailed": "Failed to unlock form responses.",
      "bookingDetailsSent": "Booking details sent to the booking contact.",
      "sendDetailsFailed": "Failed to send booking details.",
      "booking": "Booking",
      "deleteFailed": "Failed to delete booking.",
      "pageTitle": "View Booking"
    },
    "viewBookingRequest": {
      "decline": "Decline",
      "moreActions": "More Actions",
      "createInvoice": "Create Invoice",
      "sendBookingDetails": "Send Booking Details",
      "noFormAssociated": "There is no form associated with this booking.",
      "formResponsesLocked": "Form responses are locked.",
      "usersCannotModifyResponses": "Users cannot submit or modify responses.",
      "unlockResponses": "Unlock Responses",
      "lockResponses": "Lock Responses",
      "noFormSubmissions": "There are no form submissions to display. An admin can fill out the form on behalf of the user or share a link to fill out the form by clicking the Share Public Link button to copy it.",
      "reviewAdditionalOptions": "Please review the following additional options before proceeding:",
      "applyStateChangeToAll": "Apply this state change to all associated recurring bookings",
      "sendEmailNotifyingContact": "Send email notifying the booking contact of the state change",
      "send": "Send",
      "sendEmailConfirmation": "This will send an email with the booking details to",
      "theBookingContact": "the booking contact",
      "recurringSeriesNote": "The email will include all dates in the recurring series.",
      "confirmSendEmail": "Confirm & Send Email",
      "confirmSkipEmail": "Confirm & Skip Email",
      "lockSuccess": "Form responses locked!",
      "lockFailed": "Failed to lock form responses.",
      "unlockSuccess": "Form responses unlocked!",
      "unlockFailed": "Failed to unlock form responses.",
      "bookingDetailsSent": "Booking details sent to the booking contact.",
      "sendDetailsFailed": "Failed to send booking details.",
      "booking": "Booking",
      "deleteFailed": "Failed to delete booking.",
      "declineSuccess": "Booking declined successfully",
      "statusUpdated": "Status updated!",
      "pageTitle": "View Booking"
    },
    "viewBookingRequestChecklist": {
      "noChecklistsAssociated": "No checklists are associated with {name}.",
      "checklist": "Checklist",
      "saveFailed": "Could not save checklist."
    },
    "viewBookingRequestDetails": {
      "generalInformation": "General Information",
      "status": "Status:",
      "blocked": "Blocked",
      "active": "Active",
      "declined": "Declined",
      "deleted": "Deleted",
      "deletionReason": "Deletion Reason:",
      "participants": "Participants:",
      "calendarDisplayText": "Calendar Display Text:",
      "createdBy": "Created By:",
      "createdAt": "Created At:",
      "bookingInformation": "Booking Information",
      "facilities": "Facilities:",
      "dateAndTime": "Date & Time:",
      "recurring": "Recurring:",
      "reason": "Reason:",
      "bookingInstructions": "Booking Instructions:",
      "contactInformation": "Contact Information",
      "name": "Name:",
      "phone": "Phone:",
      "email": "Email:",
      "additionalDetails": "Additional Details",
      "lockerRoomOne": "Locker Room 1:",
      "lockerRoomTwo": "Locker Room 2:",
      "tags": "Tags:",
      "none": "None"
    },
    "viewBookingRequestFiles": {
      "uploadFile": "Upload File",
      "fileUploaded": "File uploaded!",
      "linkCopied": "Link copied to clipboard!"
    },
    "bookingDetails": {
      "bookingDetails": "Booking Details",
      "bookingParticipants": "Booking Participants",
      "bookingStatus": "Booking Status",
      "active": "Active",
      "deleted": "Deleted",
      "bookableEntity": "Bookable Entity",
      "bookingStartDate": "Booking Start Date",
      "bookingEndDate": "Booking End Date",
      "editBookingDate": "Edit Booking Date",
      "editDates": "Edit Dates",
      "startDate": "Start Date",
      "endDate": "End Date",
      "booking": "Booking"
    },
    "checklistContainer": {
      "createChecklist": "Create Checklist",
      "checklistDescription": "Booking checklists are visible on Booking Requests. They help you keep track of specific tasks required for each booking request."
    },
    "checklistForm": {
      "checklistName": "Checklist Name",
      "checklistNamePlaceholder": "Enter a name for the checklist here",
      "items": "Items",
      "addItem": "Add Item"
    },
    "maintenanceMode": {
      "maintenanceDescription": "By enabling this the bookings page will be inaccessible to users and the message entered below will be rendered.",
      "enableMaintenanceMode": "Enable Maintenance Mode",
      "messageDisplayedToUser": "Message Displayed to User *",
      "pleaseEnterMessage": "Please enter a message.",
      "settingsSaved": "Settings saved."
    },
    "bookingRequestDetails": {
      "bookingDetails": "Booking Details",
      "bookingParticipants": "Booking Participants",
      "bookingStatus": "Booking Status",
      "active": "Active",
      "deleted": "Deleted",
      "bookableEntity": "Bookable Entity",
      "bookingStartDate": "Booking Start Date",
      "bookingEndDate": "Booking End Date",
      "editBookingDate": "Edit Booking Date",
      "editDates": "Edit Dates",
      "startDate": "Start Date",
      "endDate": "End Date",
      "bookingCreated": "Booking created!"
    },
    "bookingPricingMatrix": {
      "howMuchDoesBookingCost": "How much does a booking cost?",
      "charge": "Charge",
      "defaultHourlyPrice": "Default hourly price",
      "perHour": "/ hour",
      "free": "Free",
      "makeDefaultHourlyPriceFree": "Make the default hourly price free",
      "chargeFlatPriceForLongerBookings": "Charge a flat price for longer bookings",
      "optional": "(optional)",
      "flatPriceExplanation": "When a booking is long enough, charge one flat total instead of the hourly rate. The longest matching rule wins.",
      "aBookingOf": "A booking of",
      "durationThresholdInHours": "Duration threshold in hours",
      "hoursOrLonger": "hours or longer",
      "costsAFlat": "costs a flat",
      "defaultFlatPrice": "Default flat price",
      "makeFlatPriceFree": "Make the flat price for {hours} hours or longer free",
      "removeFlatPrice": "Remove the flat price for bookings of {hours} hours or longer",
      "addAFlatPrice": "Add a flat price",
      "whatPeopleWillPay": "What people will pay",
      "hourBooking": "A {hours}-hour booking",
      "tryAnotherLength": "Try another length",
      "previewBookingDurationInHours": "Preview booking duration in hours",
      "hours": "hours",
      "chargeMembershipsDifferentPrice": "Charge certain memberships a different price?",
      "membershipPricing": "Membership Pricing",
      "membershipPricingExplanation": "Everyone pays the prices above unless you set a different price for their membership.",
      "hourlyPriceForMember": "Hourly price for {title}",
      "makeHourlyPriceForMemberFree": "Make the hourly price for {title} free",
      "hoursOrLongerCostsFlat": "h or longer costs a flat",
      "flatPriceForMember": "Flat price for {title} for {hours} hours or longer",
      "makeFlatPriceForMemberFree": "Make the flat price for {title} for {hours} hours or longer free",
      "theyllPay": "They'll pay",
      "freeDefault": "Free (default)",
      "valueDefault": "{value} (default)",
      "sameAsEveryone": "Same as everyone",
      "freePerHour": "Free/h",
      "amountPerHour": "{amount}/h",
      "hoursPlusFree": "{hours}h+ Free",
      "hoursPlusAmount": "{hours}h+ {amount}",
      "flatRateFrom": "flat rate from {hours}h",
      "hourlyRate": "hourly rate"
    },
    "bookingProducts": {
      "productInfoNote": "NOTE: Product info reflects the product at time of purchase."
    },
    "modalDeleteBookingProduct": {
      "removeProduct": "Remove Product",
      "areYouSureRemove": "Are you sure you want to remove",
      "fromThisBooking": "from this booking?",
      "alsoRefundAmount": "Also refund {amount} to the customer",
      "refundReason": "Refund reason",
      "refundReasonPlaceholder": "Enter reason for refund...",
      "product": "Product",
      "failedToRemoveProduct": "Failed to remove product."
    },
    "buttonGroupBookingsView": {
      "list": "List",
      "calendar": "Calendar"
    },
    "modalAssociateBooking": {
      "associateBookings": "Associate Bookings",
      "associate": "Associate",
      "searchInstructions": "Search for bookings by ID, customer, or bookable to associate them with this invoice. Add as many as you need, then click Associate."
    },
    "modalDeleteBookingState": {
      "deleteBookingState": "Delete Booking State",
      "deleteState": "Delete State",
      "bookingRequest": "booking request",
      "bookingRequests": "booking requests",
      "currentlyUse": "currently use",
      "chooseStateToMove": "Choose a state to move them to before it is deleted.",
      "moveBookingsTo": "Move bookings to",
      "selectAState": "Select a state…",
      "newStateName": "New state name",
      "newStateColor": "New state color",
      "createNewStateInstead": "Create a new state instead"
    },
    "bookingTypeRadio": {
      "pleaseSelectAType": "Please select a type.",
      "blockOffTime": "Block Off Time",
      "dropIn": "Drop-In",
      "booking": "Booking"
    },
    "adminEditBookingSidebar": {
      "editBookingNumber": "Edit Booking #{id}",
      "bookingDetails": "Booking Details",
      "facilities": "Facilities",
      "atLeastOneFacility": "At least one facility must be selected",
      "searchForAFacility": "Search for a facility",
      "lockerRoomOne": "Locker Room 1",
      "descriptionOptional": "Description (optional)",
      "lockerRoomTwo": "Locker Room 2",
      "contactName": "Contact Name",
      "required": "Required",
      "email": "Email",
      "phone": "Phone",
      "calendarDisplayText": "Calendar Display Text",
      "optional": "Optional",
      "characterCount": "{count}/30 characters",
      "reason": "Reason",
      "tags": "Tags",
      "dateAndTime": "Date & Time",
      "start": "Start",
      "startBeforeEnd": "Start date must be before end date",
      "end": "End",
      "timesShownIn": "Times shown in",
      "recurringOptions": "Recurring Options",
      "attention": "Attention:",
      "recurringSeriesPrompt": "This booking is part of a recurring series. How would you like to apply your changes?",
      "allEvents": "All events",
      "thisAndFutureEvents": "This and future events",
      "onlyThisEvent": "Only this event",
      "errorSavingBooking": "Error saving booking. Please try again or contact support.",
      "booking": "Booking",
      "facilityConflictPartialSave": "Your other changes were saved, but the facility was not added because of a scheduling conflict. Adjust the booking and try again.",
      "errorSavingContactDetails": "Error saving contact details",
      "errorSavingReason": "Error saving reason",
      "errorSavingDisplayText": "Error saving display text",
      "errorSavingTags": "Error saving tags"
    },
    "declineBookingModal": {
      "declineBooking": "Decline Booking",
      "confirmDecline": "Are you sure you want to decline this booking?",
      "declineReasonOptional": "Decline Reason (Optional)",
      "declineReasonPlaceholder": "Enter reason for declining...",
      "applyToAllRecurring": "Apply this decline to all associated recurring bookings",
      "sendEmailNotification": "Send email notifying the booking contact their booking has been declined."
    },
    "deleteBookingModal": {
      "deleteBooking": "Delete Booking",
      "irreversibleWarning": "This action is irreversible. Please confirm you would like to delete the booking.",
      "reasonForDeletion": "Reason for deletion",
      "reasonPlaceholder": "Enter reason for deleting...",
      "deleteAllRecurring": "Delete all associated recurring bookings",
      "typeDeleteToConfirm": "Type DELETE to confirm"
    },
    "baseBookingShow": {
      "requestDeclined": "This booking request has been declined. Use the status controls above to move to another state and remove the declined status.",
      "notes": "Notes",
      "activity": "Activity",
      "invoices": "Invoices",
      "recurringBookings": "Recurring Bookings",
      "formResponse": "Form Response",
      "products": "Products",
      "checklist": "Checklist",
      "files": "Files"
    },
    "bookableEntityIndex": {
      "facilities": "Facilities",
      "reorder": "Reorder",
      "resetOrder": "Reset Order",
      "saveOrder": "Save Order",
      "failedToLoadItemsForReordering": "Failed to load items for reordering.",
      "orderSaved": "Order saved. This is the order end users will see.",
      "failedToSaveOrder": "Failed to save order.",
      "manualOrderReset": "Manual order reset. End users now see the default order.",
      "failedToResetToNaturalOrder": "Failed to reset to natural order."
    },
    "availabilityCreate": {
      "basicDetails": "Basic Details",
      "name": "Name *",
      "thisFieldIsRequired": "This field is required.",
      "pricing": "Pricing",
      "pricingDescription": "Set what a booking costs. You can keep it simple with an hourly rate, or charge a flat price for longer bookings.",
      "defaultHourlyPriceRequired": "The default hourly price is required.",
      "datesAndTime": "Dates & Time",
      "days": "Days *",
      "daysDescription": "The days that this availability applies to.",
      "everyDay": "Every Day",
      "months": "Months *",
      "monthsDescription": "The months that this availability applies to.",
      "everyMonth": "Every Month",
      "startTime": "Start Time *",
      "endTime": "End Time *",
      "editAvailability": "Edit Availability",
      "createAvailability": "Create Availability",
      "availability": "Availability",
      "pleaseFixHighlightedFields": "Please fix the highlighted fields."
    },
    "availabilityIndex": {
      "headsUp": "Heads up!",
      "parentEntityNotice": "You cannot create availabilities for this facility because it has a parent facility. It will inherit availabilities from the parent facility.",
      "viewParentAvailabilities": "To view the availabilities for the parent facility, please go to the",
      "parentFacilityAvailabilities": "parent facility availabilities",
      "availabilities": "Availabilities"
    },
    "bookingItemAssign": {
      "assignLockerRooms": "Assign Locker Rooms",
      "generateMediaScreen": "Generate Media Screen",
      "bookableEntity": "Bookable Entity",
      "bookingDate": "Booking Date",
      "selectDate": "Select date...",
      "noBookingsFound": "No bookings found for the date and entity specified.",
      "addCustomTime": "Add Custom Time",
      "reloadBookings": "Reload Bookings",
      "deleteRow": "Delete Row",
      "descriptorOptional": "Optional. Enter an extra descriptor for this booking and related booking item.",
      "startTime": "Start Time",
      "endTime": "End Time",
      "lockerRoomOne": "Locker Room 1",
      "lockerRoomOneDescriptor": "Locker Room 1 Descriptor",
      "lockerRoomTwo": "Locker Room 2",
      "lockerRoomTwoDescriptor": "Locker Room 2 Descriptor",
      "assignments": "Assignments",
      "failedToSaveAssignments": "Failed to save assignments"
    },
    "bookingItemIndex": {
      "lockerRooms": "Locker Rooms",
      "assignLockerRooms": "Assign Locker Rooms"
    },
    "bookingListIndex": {
      "title": "Bookings List",
      "description": "Search and manage bookings below.",
      "buildInvoice": "Build Invoice",
      "notApplicable": "N/A",
      "paid": "Paid",
      "unpaid": "Unpaid",
      "display": "Display:",
      "reason": "Reason:",
      "confirmBuildInvoice": "Are you sure you want to create an invoice for the selected bookings?",
      "createInvoice": "Create Invoice",
      "pageTitle": "Manage Bookings",
      "declined": "Declined",
      "facilityFilter": "Facility",
      "stateFilter": "State",
      "tagsFilter": "Tags",
      "bookingsDeletedSuccessfully": "Bookings deleted successfully",
      "failedToDeleteBookings": "Failed to delete bookings"
    },
    "uploadUserFile": {
      "selectFile": "Select a File",
      "maxFileSize": "Maximum file size is 10MB.",
      "fileRequiredFeedback": "This field is required and must be 10MB or less.",
      "nameOfFile": "Name of File",
      "nameRequiredFeedback": "This field is required.",
      "namePlaceholder": "Name of the file"
    },
    "bookableEntityCreateForm": {
      "sectionBasicInformation": "1. Basic Information",
      "nameLabel": "Name *",
      "fieldRequired": "This field is required.",
      "namePlaceholder": "Enter a name for your bookable thing",
      "descriptionLabel": "Description *",
      "descriptionPlaceholder": "Enter a description for this bookable thing",
      "membershipsRequiredLabel": "Memberships Required to Book",
      "membershipsRequiredDescription": "Enforce users to hold a specific membership to create bookings.",
      "membershipLogicLabel": "Membership Requirement Logic",
      "membershipLogicDescription": "Choose whether users must hold any selected membership or every selected membership.",
      "associatedBookableEntityLabel": "Associated Bookable Entity",
      "applyTaxRatesToFacilityLabel": "Apply tax rates to this facility",
      "taxInheritedPrefix": "Tax settings are inherited from",
      "taxInheritedSuffix": ". To change tax behavior, update the parent facility.",
      "applyTaxRatesCheckbox": "Apply tax rates",
      "minimumBookingLengthLabel": "Minimum Booking Length *",
      "lengthInHours": "Length in hours",
      "maximumBookingLengthLabel": "Maximum Booking Length *",
      "capacityLabel": "Capacity",
      "capacityDescription": "The total amount of people that this facility can hold at a given time.",
      "bookingInstructionsLabel": "Booking Instructions",
      "bookingInstructionsHelp": "Custom instructions that will be included in the confirmation email sent to users when their booking is completed.",
      "sectionBookingConfiguration": "2. Booking Configuration",
      "parentSettingsMatch": "Since this entity has an Associated Bookable Entity, these settings will match what is set for",
      "bookingTypeLabel": "Booking Type",
      "publicSettingsLabel": "Public Settings",
      "exposePublicCheckbox": "Expose this entity to the public so they can view the calendar.",
      "hideUserNamesCheckbox": "Hide the names of the individuals that hold a booking on calendars.",
      "allowPublicBookingsCheckbox": "Allow the public to create bookings.",
      "userCreationSettingsLabel": "User Creation Settings",
      "allowBookingOwnerCheckbox": "Allow setting of booking owner.",
      "bookingOwnerHelp": "User can set themselves as the booking owner or a member on their account.",
      "allowAdditionalUsersCheckbox": "Allow ability to add additional users to booking.",
      "additionalUsersHelp": "User can add one or more additional account holders to the booking signup.",
      "allowGuestsCheckbox": "Allow number of guests.",
      "guestsHelp": "User can add guests to the booking signup.",
      "userSettingsLabel": "User Settings",
      "allowRecurringCheckbox": "Allow users to create recurring bookings.",
      "allowReasonCheckbox": "Allow users to specify a title/reason for their booking.",
      "reasonHelp": "This will allow users to enter a custom title (reason) for their booking. It will be displayed on the calendar. Max length is 30 characters.",
      "managerSettingsLabel": "Manager Settings",
      "managerOnlyCheckbox": "Only display this entity for managers in the manager dashboard.",
      "managerOnlyHelp": "Prevent this calendar from showing to users. Useful for a private calendar for managers only.",
      "bookingStatesLabel": "Booking States",
      "bookingStatesHelp": "At least two booking states are required for booking request functionality.",
      "bookingStatesNeededPrefix": "Booking states",
      "mustBeCreated": "must be created",
      "bookingStatesNeededSuffix": "before creating a 'Request' type bookable entity.",
      "requestTypeRequired": "This field is required if booking type is 'Request'.",
      "bookingChecklistLabel": "Booking Checklist",
      "minimumDaysLabel": "Minimum Days Before End-Users Can Create a Booking Request",
      "minimumDaysHelp": "Number of days required to accommodate the booking request",
      "futureDaysLabel": "Number of Days User Can See Ahead",
      "futureDaysDescription": "The number of days the user can view ahead in the future on the calendar (default: 14 days).",
      "mustBeGreaterThanZero": "Must be a number greater than zero.",
      "resetTimeLabel": "Reset Time",
      "resetTimeDescription": "Allows you to set a time for the booking request deadline to reset each day. Defaults to midnight.",
      "defaultViewLabel": "Default Booking View",
      "defaultViewDescription": "The default view the user will see when initially creating a booking.",
      "bookingIntervalLabel": "Booking Time Interval",
      "bookingIntervalDescription": "The time interval (in minutes) used for booking time selection.",
      "sectionImages": "3. Images",
      "imagesTooLarge": "One or more images are too large. Make sure each image is 10MB or less.",
      "currentImages": "Current Images",
      "noImagesUploaded": "No images uploaded.",
      "sectionProducts": "4. Products",
      "productsNote": "NOTE: Currently products will only be purchasable on paid bookings.",
      "productsManagedOn": "Products and product configuration are managed on",
      "noProductsLinked": "No products linked."
    },
    "inputBookingSearch": {
      "searchBookings": "Search bookings",
      "selectedBookings": "Selected bookings:"
    },
    "inputBookingTags": {
      "searchOrAddATag": "Search or add a tag"
    },
    "calendarAdmin": {
      "show": "Show",
      "programs": "Programs",
      "status": "Status",
      "timesShownIn": "Times shown in",
      "subscribe": "Subscribe",
      "noAvailabilitiesConfigured": "No availabilities are configured for this calendar view.",
      "scrollLeft": "Scroll left",
      "scrollRight": "Scroll right",
      "quickCreateBooking": "Quick create booking"
    },
    "waitlistAddSignupSidebar": {
      "addToWaitlist": "Add to Waitlist",
      "user": "User",
      "fieldRequired": "This field is required.",
      "registrationOpportunity": "Registration Opportunity",
      "registrationOpportunityRequired": "A registration opportunity is required.",
      "noWaitlistEnabledOpportunities": "No waitlist-enabled registration opportunities are available."
    },
    "pageCalendarIndex": {
      "title": "Booking Calendar"
    },
    "bookingItemCreate": {
      "nameLabel": "Name *",
      "namePlaceholder": "Enter a name for the item",
      "descriptionLabel": "Description *",
      "descriptionPlaceholder": "Describe your item"
    }
  },
  "guest": {
    "displayBookingStatus": {
      "yourBooking": "Your Booking",
      "bookableImage": "Bookable Image",
      "requestId": "Request ID",
      "currentStatus": "Current Status",
      "noBookingFound": "No booking could be found with the given ID."
    }
  }
}
